<!-- @format -->

<template>
  <div class="ui sixteen column grid centered">
    <div class="sixteen wide column" style="padding: 1em 0em 0em 2em">
      <h5>
        [ {{ assumptions.result.description }}] - Capital market assumptions
      </h5>
      Long-term inflation rate:
      <strong>{{ formatNr(assumptions.result.expectedInflationRate) }} </strong>

      <table class="ui table" style="font-size: xx-small">
        <thead>
          <tr>
            <th>Description</th>
            <th>Exp return (%)</th>
            <th>Exp annualised vol (%)</th>
          </tr>
        </thead>

        <tr v-for="a in assumptions.arrayFormat">
          <td>{{ a.name }}</td>
          <td>
            {{
              formatNr(
                a.expectedNominalReturn +
                  assumptions.result.expectedInflationRate
              )
            }}
          </td>
          <td>
            {{ formatNr(a.standardDeviation) }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
//import { getPortfolios, AssetAllocation } from "@/utils/portfolios.js";
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
export default {
  name: "home",
  components: { vSelect },
  computed: {},
  props: ["aaType", "assumptions"],
  data() {
    return {};
  },

  methods: {
    formatNr(val) {
      return numeral(val).format("0,0.0%");
    },
  },
  mounted() {},
};
</script>
